import * as React from "react";
import { cloneDeep } from "lodash";
import { match } from "react-router";
import { toastr } from "react-redux-toastr";
import PerfectScrollbar from "perfect-scrollbar-react";
import SidebarContainer from "src/modules/Routing/Sidebar/SidebarContainer";
import GSPImage from "./components/GSPImage";
import GSPSourceInformation from "./components/GSPSourceInformation";
import GSPImageDetails from "./components/GSPImageDetails";
import GSPDeviceInformation from "./components/GSPDeviceInformation";
import { GeoSearchService } from "src/share/services/geoSearch";
import { renderLoadedText } from "src/share/utils/placeholders";
import { timestampToLongDate } from "src/share/utils/utils";
import "./GeoSearchPhoto.css";
import { RoutesModules } from "src/modules/Routing/types";

interface IGeoSearchFace {
  BoundingBox: { Height: number; Left: number; Top: number; Width: number };
  Confidence: number;
  FaceId: string;
}
interface IGeoSearchPhotoProps {
  match: match<{ photoId: string }>;
  history: any;
}
interface IGeoSearchPhotoState {
  photo: {
    creator: string;
    dateTimeOriginal: any;
    dateLastSeen: any;
    domain: string;
    faces: IGeoSearchFace[];
    host: string;
    latitude: number;
    lens: string;
    lensSerialNumber: string;
    longitude: number;
    make: string;
    md5: string;
    model: string;
    knownChildAbuseImageArachnid: boolean;
    owner: string;
    photoDNAFullHash: string;
    serialNumber: string;
    sha1: string;
    source: string;
    radius: number;
    url: string;
    originalUrl: string
    width: number
    height: number
  };
  isLoading: boolean;
}
const initialGeosearchPhoto = {
  creator: "",
  dateLastSeen: new Date().getTime(),
  dateTimeOriginal: new Date().getTime(),
  domain: "",
  faces: [],
  host: "",
  make: "",
  md5: "",
  model: "",
  latitude: 0,
  lens: "",
  lensSerialNumber: "",
  knownChildAbuseImageArachnid: false,
  longitude: 0,
  owner: "",
  photoDNAFullHash: "",
  radius: 1,
  serialNumber: "",
  sha1: "",
  source: "",
  url: "",
  originalUrl: "",
  height: 1920,
  width: 1080,
};

export class GeoSearchPhoto extends React.PureComponent<IGeoSearchPhotoProps, IGeoSearchPhotoState> {
  public constructor(props) {
    super(props);
    this.state = {
      photo: cloneDeep(initialGeosearchPhoto),
      isLoading: true
    };
  }
  public async componentDidMount() {
    const { photoId } = this.props.match.params;
    try {
      const result = await GeoSearchService.getPhotoById(photoId);
      this.setState({ photo: result, isLoading: false });
    } catch (error) {
      toastr.error("Error", error.payload);
      if (error.status === 404) {
        this.props.history.push(`/not-found`);
      }
    }
  }
  public render() {
    const { photo, isLoading } = this.state;
    return (
      <div className="geosearch-photo__content">
        <PerfectScrollbar>
          <div className="geosearch-photo__container white-background">
            <GSPImage src={photo.url} height={photo.height} width={photo.width} faces={photo.knownChildAbuseImageArachnid ? [] : photo.faces} />
            <GSPSourceInformation
              host={renderLoadedText(photo.host, !isLoading)}
              domain={renderLoadedText(photo.domain, !isLoading)}
              imageURL={renderLoadedText(photo.originalUrl || photo.url, !isLoading, 1, 100)}
              sourceURL={renderLoadedText(photo.source, !isLoading, 1, 100)}
              knownChildAbuseImageArachnid={photo.knownChildAbuseImageArachnid} />
            <GSPImageDetails
              creator={renderLoadedText(photo.creator, !isLoading)}
              originalDate={renderLoadedText(photo.dateTimeOriginal, !isLoading, 1, 75, timestampToLongDate)}
              lastSeen={renderLoadedText(photo.dateLastSeen, !isLoading, 1, 75, timestampToLongDate)}
              photoDNA={renderLoadedText(photo.photoDNAFullHash, !isLoading)}
              sha1={renderLoadedText(photo.sha1, !isLoading)}
              md5={renderLoadedText(photo.md5, !isLoading)}
              center={{ lat: photo.latitude, lng: photo.longitude }}
              radius={renderLoadedText(photo.radius, !isLoading)}
            />
            <GSPDeviceInformation
              brand={renderLoadedText(photo.make, !isLoading)}
              model={renderLoadedText(photo.model, !isLoading)}
              serialNumber={renderLoadedText(photo.serialNumber, !isLoading)}
              lens={renderLoadedText(photo.lens, !isLoading)}
              lensSerialNumber={renderLoadedText(photo.lensSerialNumber, !isLoading)}
              owner={renderLoadedText(photo.owner, !isLoading)}
            />
          </div>
        </PerfectScrollbar>
      </div>
    );
  }
}

export default SidebarContainer(RoutesModules.GEOSEARCH)(GeoSearchPhoto);
